import { useNavigate } from 'react-router-dom';
import { FormUtility } from '../../Utility/FormUtility';
import { useSelector } from 'react-redux';
import { rolesCodes } from '../../../constants/Roles';
import { useEffect } from 'react';

export default function Home() {
  const navigate = useNavigate();
  const roles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: roles });

  useEffect(() => {
    utility.clearSessionStorageBySuffixes(['_options', '_filtri_avanzati']);
  }, []);

  return (
    <div className='rtds-container-xxs rtds-py-6'>
      <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
        <div className='rtds-flex rtds-items-center rtds-justify-between'>
          <h1 className='rtds-heading-2'>Menù</h1>
        </div>
        <div className='rtds-flex rtds-justify-center'>
          <div className='rtds-w-full'>
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button 
                type='button'
                onClick={() => navigate('/gestione-avvisi')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Avvisi
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-fasi')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Fasi
              </button>
            }
            {/* {
              utility.checkRoles([rolesCodes.comune, rolesCodes.comuneReferente, rolesCodes.regione]) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-comuni-librerie')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Librerie
              </button>
            } */}
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-adesione-enti')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--building-library`}
                  />
                </svg> Anagrafe Enti
              </button>
            }
            {
              (
                utility.checkRoles([rolesCodes.regione]) ||
                (
                  utility.checkRoles([rolesCodes.comuneReferente]) && 
                  roles.referenze.find(r => r.id.toString() === roles.enteSelected)
                )
              ) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-operatori' + (utility.checkRoles([rolesCodes.comuneReferente]) ? '/' + roles.enteSelected : ''))}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--users`}
                  />
                </svg> Operatori comunali
              </button>
            }
            {
              (
                utility.checkRoles([rolesCodes.regione]) 
              ) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-indirizzi-studio' )}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--academic-cap`}
                  />
                </svg> Scuole e indirizzi di studio
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button 
                type='button'
                onClick={() => navigate('/gestione-domande')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Domande
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button 
                type='button'
                onClick={() => navigate('/gestione-errori')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Errori
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button 
                type='button'
                onClick={() => navigate('/gestione-eventi')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Eventi
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button 
                type='button'
                onClick={() => navigate('/gestione-email')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Email Massive
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-pagamenti')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione Pagamenti
              </button>
            }
            {
              utility.checkRoles([rolesCodes.regione]) &&
              <button
                type='button'
                onClick={() => navigate('/gestione-istruttorie')}
                className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary'
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                  />
                </svg> Gestione istruttorie ARS
              </button>
            }
          </div>
        </div>
        {/*<div>
          <p className='rtds-text-center'>
            Per eventuali quesiti è possibile inoltrare una mail a <a className='rtds-link ' href='mailto:librigratis@regione.toscana.it'>librigratis@regione.toscana.it</a>
          </p>
        </div>*/}
      </div>
    </div>
  );
}
